export const RE_AUTHENTICATE_REQUIRED = 'RE_AUTHENTICATE_REQUIRED';
